import React from 'react';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import DurationPicker from 'main/components/show/cuesheet/durationPicker.jsx';
import ActualDuration from 'main/components/show/cuesheet/actualDuration.jsx';
import TimeUtil from 'time';
import RoleHelper from 'shared/lib/role';
import classNames from 'classnames';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import PopoverActions from 'flux/actions/PopoverActions';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';

/**
 * Duration cell
 *
 */
export default React.createClass({
  displayName: 'ItemDurationCell',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  propTypes: {
    user: React.PropTypes.object,
    item: React.PropTypes.any.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    showRunTimeSuppressionToggle: React.PropTypes.bool,
    simple: React.PropTypes.bool,
    displayDuration: React.PropTypes.bool,
    displayActualDuration: React.PropTypes.bool,
  },

  render() {
    const {
      item,
      rowIndex,
      simple,
      user,
      displayDuration,
      displayActualDuration,
      durationDisplayType,
      isSelected,
      value,
    } = this.props;

    if (!displayDuration) return null;

    const displayDurationClock = item.get('displayDurationClock');
    const durationInSeconds = item.get('durationInSeconds');

    let durationText = TimeUtil.getShorthandDuration(durationInSeconds);

    if (durationDisplayType === TimeDisplayTypes.clockTime) {
      durationText = TimeUtil.getShorthandFormattedPresetDuration(
        durationInSeconds,
      );
    }
    if (durationDisplayType === TimeDisplayTypes.sixDigitTime) {
      durationText = TimeUtil.getFormattedDuration(durationInSeconds);
    }

    let wrapperClasses = classNames('cs-wrapper-duration-time', {
      'show-on-hover': !displayDurationClock,
    });

    const placement = simple ? 'top' : 'left';

    if (!this._hasAdmin())
      return this._getDisplayNode(durationText, wrapperClasses);

    return (
      <div className={wrapperClasses} onClick={this._handleClick}>
        <div>
          <DurationPicker
            {...{ rowIndex, simple, item, user, isSelected }}
            displayType={durationDisplayType}
            durationText={durationText}
            placement={placement}
            showRunTimeSuppressionToggle={
              this.props.showRunTimeSuppressionToggle
            }
            showSuppressionToggle
            isSuppressed={item.get('durationSuppressed')}
            isRunTimeSuppressed={item.get('runTimeClockSuppressed')}
            displayDurationClock={displayDurationClock}
            displayActualDuration={displayActualDuration}
            displayNode={this._getDisplayNode(durationText)}
            value={value}
            onTab={this._handleTab}
            onSuppressionChanged={this._handleDurationSuppressionChange}
            onRunTimeSuppressionChanged={
              this._handleItemRunTimeSuppressionChange
            }
          />
          {this._getActualDurationNode()}
        </div>
        {this._getSuppressionNode()}
        {this._getToggleDurationNode()}
      </div>
    );
  },

  _handleClick() {
    const { isSelected, rowIndex } = this.props;

    if (readOnlyHelper.alertPastEventNotEditable()) {
      return;
    }

    if (isSelected) {
      const popoverId = EditableCellTypes.ItemDuration + rowIndex;
      PopoverActions.show(popoverId);
    } else {
      this._select();
    }
  },

  _getDisplayNode(durationText, wrapperClasses) {
    let classes = classNames('cs-duration-cell read-only', {
      'input-duration-wrapper': !this._hasAdmin(),
    });

    let durationCell = <div className={classes}>{durationText}</div>;

    if (!wrapperClasses) {
      return durationCell;
    }

    return (
      <div className={wrapperClasses}>
        <div>
          {durationCell}
          {this._getActualDurationNode()}
        </div>
      </div>
    );
  },

  _getActualDurationNode() {
    const { displayActualDuration, isTracked, item } = this.props;
    const durationInSeconds = item.get('durationInSeconds');
    const actualDurationInSeconds = item.get('actualDurationInSeconds');

    return (
      <ActualDuration
        actualDurationInSeconds={actualDurationInSeconds}
        displayActualDuration={displayActualDuration}
        durationInSeconds={durationInSeconds}
        isTracked={isTracked}
      />
    );
  },

  _getSuppressionNode() {
    const { item } = this.props;

    const displayDurationClock = item.get('displayDurationClock');
    const durationSuppressed = item.get('durationSuppressed');
    const runTimeClockSuppressed = item.get('runTimeClockSuppressed');

    if (!displayDurationClock) return null;

    let suppressedNode = null,
      itemRunTimeSuppressedNode = null;

    if (durationSuppressed && this._hasAdmin()) {
      suppressedNode = this._getDurationSuppressedIconNode();
    }
    if (runTimeClockSuppressed && this._hasAdmin()) {
      itemRunTimeSuppressedNode = this._getItemRunTimeSuppressedIconNode();
    }

    return durationSuppressed || runTimeClockSuppressed ? (
      <div className="cs-mute-duration">
        {suppressedNode}
        {itemRunTimeSuppressedNode}
      </div>
    ) : null;
  },

  _getToggleDurationNode() {
    const { item } = this.props;

    const displayDurationClock = item.get('displayDurationClock');

    let iconName = displayDurationClock ? 'eye' : 'eye-slash';

    return <Icon name={iconName} onClick={this._toggleDuration} />;
  },

  _getDurationSuppressedIconNode() {
    const { item } = this.props;
    const durationSuppressed = item.get('durationSuppressed');

    return (
      <Icon
        name="duration_muted"
        onClick={() =>
          this._handleDurationSuppressionChange(!durationSuppressed)
        }
        ours
      />
    );
  },

  _getItemRunTimeSuppressedIconNode() {
    const { item } = this.props;
    const runTimeClockSuppressed = item.get('runTimeClockSuppressed');

    return (
      <Icon
        name="hourglass_muted"
        onClick={() =>
          this._handleItemRunTimeSuppressionChange(!runTimeClockSuppressed)
        }
        ours
      />
    );
  },

  _hasAdmin() {
    const params = this.context.router.state.params;
    const { teamId, eventId } = params;

    return RoleHelper.hasEventAdminRole(this.props.user, teamId, eventId);
  },

  _toggleDuration(e) {
    e.stopPropagation();
    const { item, rowIndex } = this.props;

    const displayDurationClock = item.get('displayDurationClock');

    const changes = {
      displayDurationClock: !displayDurationClock,
      runTimeClockSuppressed: displayDurationClock,
      durationSuppressed: displayDurationClock,
    };

    CuesheetCellActions.saveItemTimeFields(rowIndex, changes);
  },

  _select() {
    CuesheetCellActions.selectTimeCell(
      this.props.rowIndex,
      EditableCellTypes.ItemDuration,
    );
  },

  _handleTab() {
    CuesheetCursorActions.moveCursorRight();
  },

  _handleDurationSuppressionChange(isSuppressed) {
    CuesheetCellActions.saveItemTimeField(
      this.props.rowIndex,
      'durationSuppressed',
      isSuppressed,
    );
  },

  _handleItemRunTimeSuppressionChange(isSuppressed) {
    CuesheetCellActions.saveItemTimeField(
      this.props.rowIndex,
      'runTimeClockSuppressed',
      isSuppressed,
    );
  },
});
